<progress-spinner *ngIf="isLoading"> </progress-spinner>
<div class="applications-details-wrapper">
  <div class="widget-wrapper">
    <mat-card>
      <div class="headline">
        <div class="headline-wrapper">
          <div class="headline-title title">
            <span>{{ title }}</span>
          </div>
          <div class="headline-divider"></div>

          <div class="headline-action-button">
            <div class="action">
              <div>
                <button
                  *ngIf="authorized"
                  mat-button
                  class="btn"
                  color="primary"
                  (click)="addApplication()"
                  i18n="add button|Add button into applications page@@addButtonApplicationsPage"
                >
                  <i class="mdi mdi-plus"></i> Add new
                </button>
              </div>
            </div>
            <ng-template #action>
              <ng-container class="headline-action-button">
                <button
                  [matMenuTriggerFor]="menu"
                  mat-button
                  class="action-button mat-menu-trigger btn-menu-trigger actions-btn mat-button mat-button-base"
                  aria-label="Open menu"
                  [disabled]="isActionsDisabled"
                >
                  <span class="mat-button-wrapper"><i class="material-icons">more_horiz</i></span>
                </button>

                <mat-menu #menu="matMenu">
                  <button
                    class="mat-menu-item-btn"
                    mat-menu-item
                    (click)="sendAction({ method: 'delete', action: 'remove', data: null })"
                    aria-label="Remove"
                  >
                    <mat-icon> delete</mat-icon>
                    <span>Remove</span>
                  </button>
                </mat-menu>
              </ng-container>
            </ng-template>
          </div>
        </div>
      </div>
      <div class="content">
        <viavi-table
          [tableConfigurations]="table"
          [isActionEnabled]="true"
          [template]="action"
          (rowClicked)="onTableRowClick($event)"
          (onDataFiltered)="onTableFiltered($event)"
        >
        </viavi-table>
      </div>
    </mat-card>
  </div>
  <div class="details-wrapper">
    <nrwl-applications-details-widget
      [data]="applicationDetails"
      (deleteApplicationEvent)="deleteApplicationEvent($event)"
    >
    </nrwl-applications-details-widget>
  </div>
</div>
